export const GROUPS = [
  { key: "sizes", label: "Size", multi: false, field: "size" },
  { key: "levels", label: "Level Pedas", multi: false, field: "level" },
  { key: "toppings", label: "Topping", multi: true, field: "toppings" },
];

export const EMPTY_SEL = { toppings: [], sizes: null, levels: null };

const items = (p, key) => (p[key]?.enabled ? p[key].items || [] : []);

export const hasOptions = (p) => GROUPS.some((g) => items(p, g.key).length > 0);

export const defaultSel = (p) => ({
  toppings: [],
  sizes: p.sizes?.required && items(p, "sizes").length ? 0 : null,
  levels: p.levels?.required && items(p, "levels").length ? 0 : null,
});

export const selected = (p, sel) => {
  const out = [];
  ["sizes", "levels"].forEach((k) => {
    const it = sel[k] != null ? items(p, k)[sel[k]] : null;
    if (it) out.push({ key: k, ...it });
  });
  (sel.toppings || []).forEach((i) => {
    const it = items(p, "toppings")[i];
    if (it && it.available !== false) out.push({ key: "toppings", ...it });
  });
  return out;
};

export const selError = (p, sel) => {
  const g = GROUPS.find((g) => !g.multi && p[g.key]?.required && items(p, g.key).length && sel[g.key] == null);
  return g ? `Pilih ${g.label}` : "";
};

export const encodeSel = (sel) => {
  if (!sel.toppings?.length && sel.sizes == null && sel.levels == null) return "";
  return `t${[...sel.toppings].sort((a, b) => a - b).join(".")}s${sel.sizes ?? ""}l${sel.levels ?? ""}`;
};

export const decodeSel = (code) => {
  const m = /^t([\d.]*)s(\d*)l(\d*)$/.exec(code || "");
  if (!m) return EMPTY_SEL;
  return { toppings: m[1] ? m[1].split(".").map(Number) : [], sizes: m[2] === "" ? null : Number(m[2]), levels: m[3] === "" ? null : Number(m[3]) };
};

export const makeLine = (p, sel, qty) => {
  const chosen = selected(p, sel);
  const code = encodeSel({ ...sel, toppings: (sel.toppings || []).filter((i) => items(p, "toppings")[i] && items(p, "toppings")[i].available !== false) });
  const pickName = (k) => chosen.find((c) => c.key === k)?.name ?? null;
  return {
    ...p,
    key: code ? `${p.id}~${code}` : p.id,
    code,
    qty,
    base_price: p.price,
    price: p.price + chosen.reduce((s, c) => s + c.price, 0),
    label: chosen.map((c) => c.name).join(", "),
    options: { toppings: chosen.filter((c) => c.key === "toppings").map((c) => c.name), size: pickName("sizes"), level: pickName("levels") },
  };
};
